import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  mainRow: {
    '& > td:first-child': {
      width: '60%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    '& > td:nth-child(2)': {
      width: '40%',
      borderLeft: '1px solid #E0E0E0'
    }
  },
  collapseRow: {
    width: '100%',
    display: 'flex',
    '& > td': {
      maxWidth: 'none'
    },
    '& > td:first-child': {
      width: '60%',
      paddingLeft: '24px !important',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    '& > td:nth-child(2)': {
      width: '40%',
      paddingLeft: '7px',
      borderLeft: '1px solid #E0E0E0'
    }
  },
  cellRightScroll: {
    marginRight: '-15px'
  }
});
